import { getVerticalDpiFromSingleImageBlob } from './dpi-from-blob';

export interface ImageMeta {
    width: number;
    height: number;
    size: number;
    type: string;
    verticalDpi: number;
}

class ImageMetaExtractor {
    public static async extractBlob(blob: Blob): Promise<ImageMeta> {
        const image = new Image();
        return new Promise((resolve, reject) => {
            const url = URL.createObjectURL(blob);
            image.src = url;
            image.onload = async () => {
                URL.revokeObjectURL(url);
                const verticalDpi = await getVerticalDpiFromSingleImageBlob(blob);
                resolve({
                    width: image.width,
                    height: image.height,
                    size: blob.size,
                    type: blob.type,
                    verticalDpi,
                });
            };
            image.onerror = () => {
                reject(new Error('[ImageMetaExtractor] failed to extract image meta'));
            };
        });
    }

    public static async extractUrl(url: string): Promise<{ width: number, height: number }> {
        const image = new Image();
        return new Promise((resolve, reject) => {
            image.src = url;
            image.onload = () => {
                URL.revokeObjectURL(url);
                resolve({
                    width: image.width,
                    height: image.height,
                });
            };
            image.onerror = () => {
                reject(new Error('[ImageMetaExtractor] failed to extract image meta'));
            };
        });
    }
}

export default ImageMetaExtractor;
